import { InvoiceEditorVariant } from '../../enums/invoiceEditorVariant'

export const invoiceDraftEditFromQuoteVariants = [
  InvoiceEditorVariant.DepositInvoiceDraftEdit,
  InvoiceEditorVariant.FinalInvoiceDraftEdit,
  InvoiceEditorVariant.InvoiceDraftEdit,
]
